<template>
    <div class="get-medal-pop-wrapper" v-if="isNeedPopData">
        <div class="get-medal-infor">
            <div class="close-popup"><a href="javascript:;" @click="closePopup"></a></div>
            <div class="dialog-desc">
                <p class="zoom">
                    <img src="../../images/personal_center/medal_07.png" v-show="isNeedPopData.type === 'Gold'"/>
                    <img src="../../images/personal_center/medal_08.png" v-show="isNeedPopData.type === 'Silver'"/>
                    <img src="../../images/personal_center/medal_09.png" v-show="isNeedPopData.type === 'Copper'"/>
                </p>
                <p class="desc">{{isNeedPopData.desc}}</p>
            </div>
            <div class="link-wrapper">
                <a href="javascript:;" class="go-link" @click="goLink">点击查看我获得的奖牌</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        isNeedPopData: {
            type: Object
        },
        isShowNeedPop: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closePopup () {
           this.$emit('update:isShowNeedPop', false);     
        },
        goLink () {
            let isDialog = new Promise((resolve, reject) => {
                resolve(this.localData());
                
            });
            isDialog.then(() => {
                let routeData = this.$router.resolve({
                    name: "medal"
                });
                window.open(routeData.href, '_blank');
            });
        },
        localData () {
            this.$emit('update:isShowNeedPop', false);
            localStorage.setItem('medalType', 'myMedal');
        }
    }
}
</script>
<style scoped type="text/scss" lang="scss">
 .get-medal-pop-wrapper{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 11110;
    transition: all 0.3s ease;
    &.fade-enter-active, .fade-leave-active {
        transition: opacity .5s
      }
      &.fade-enter, .fade-leave-to{
        opacity: 0;
      }
    .get-medal-infor{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 480px;
        height: 240px;
        background-color: #ffffff;
        box-shadow: 0px 4px 8px 0px rgba(4, 0, 0, 0.1);
        border-radius: 4px;
        border: solid 1px rgba(0, 0, 0, 0.1);
        .close-popup{
            padding-right: 22px;
            display: block;
            width: 100%;
            height: 70px;
            line-height: 70px;
            text-align: right;
            a{
                display: inline-block;
                width: 18px;
                height: 18px;
                background: url("../../images/personal_center/pop-close.png") no-repeat 95% center;
                background-size: 18px 18px;
            }
        }
        .dialog-desc{
            padding: 0 0 0 72px;
            .zoom,.desc{
                display: inline-block;
                vertical-align: middle;
            }
            .desc{
                margin-left: 24px;
                width: 245px;
                color: #7b7d8a;
                font-size: 16px;
                line-height: 30px;
                .medal-name{
                   font-weight: bold;
                }
            }
        }
        .link-wrapper{
            position: absolute;
            bottom: 0;
            left: 0;
            display: block;
            padding: 12px 0; 
            width: 100%;
            line-height: 0;
            font-size: 0;
            background-color: #f4f4f4;
            border-radius: 0px 0px 4px 4px;
            text-align: center;
            .go-link{
                display: inline-block;
                width: 185px;
                height: 36px;
                font-size: 14px;
                line-height: 36px;
                color: #7b7d8a;
                background-color: #ffffff;
                border: solid 1px rgba(0, 0, 0, 0.1);
            }
        }
    }
 }


</style>





// WEBPACK FOOTER //
// getMedalPop.vue?5997447c